import { ConfigService } from '../../infra/config'
import { BaseRepository } from '../../infra/base.repository'
import type { Charge } from './charge.entity'
import type { RefundChargeInputDto, RefundChargePreviewDto } from './dto/refund-charge.dto'

export class ChargesRepository extends BaseRepository<Charge> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.paymentApiUrl + '/charges', token, cache)
    }

    async void(chargeId: string) {
        const { json, statusCode, message } = await this.request.get(
            this.config.paymentApiUrl + '/charges/' + chargeId + '/void?token=' + this.resolvedToken,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async paid(chargeId: string) {
        const { json, statusCode, message } = await this.request.get(
            this.config.paymentApiUrl + '/charges/' + chargeId + '/paid?token=' + this.resolvedToken,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async getBoleto(chargeId: string, invoiceId: string) {
        const { json, statusCode, message } = await this.request.get(
            this.config.paymentApiUrl + '/charges/' + chargeId + '/boleto?invoice=' + invoiceId + '&token=' + this.resolvedToken,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async getPix(chargeId: string) {
        const { json, statusCode, message } = await this.request.get(
            this.config.paymentApiUrl + '/charges/' + chargeId + '/pix?token=' + this.resolvedToken,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async refreshPix(chargeId: string) {
        const { json, statusCode, message } = await this.request.get(
            this.config.paymentApiUrl + '/charges/' + chargeId + '/pix/refresh?token=' + this.resolvedToken,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    // 'method' ausente emite boleto, que era o comportamento unico desta rota antes do pix
    async singleCharge(chargeId: string, method?: string) {
        const { json, statusCode, message } = await this.request.get(
            this.config.paymentApiUrl +
                '/charges/' +
                chargeId +
                '/single-charge?token=' +
                this.resolvedToken +
                (method ? '&method=' + method : ''),
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async retry(chargeId: string) {
        const { json, statusCode, message } = await this.request.get(
            this.config.paymentApiUrl + '/charges/' + chargeId + '/retry?token=' + this.resolvedToken,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async gatewaySync(chargeId: string) {
        const { json, statusCode, message } = await this.request.get(
            this.config.paymentApiUrl + '/charges/' + chargeId + '/refresh?token=' + this.resolvedToken,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    // o que aconteceria ao estornar: se pode, quanto, se invalida ou devolve, e se cabe parcial
    async refundPreview(chargeId: string, amount?: number, invoiceId?: string): Promise<RefundChargePreviewDto> {
        let extra = amount ? '&amount=' + amount : ''
        // sem invoiceId a api decide sozinha quando há um pagamento só; com mais de um ela recusa e
        // devolve a lista, para a tela perguntar qual desfazer
        if (invoiceId) extra += '&invoiceId=' + invoiceId
        const { json, statusCode, message } = await this.request.get(
            this.config.paymentApiUrl + '/charges/' + chargeId + '/refund/preview?token=' + this.resolvedToken + extra,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async refund(chargeId: string, dto: RefundChargeInputDto): Promise<RefundChargePreviewDto> {
        const { json, statusCode, message } = await this.request.post(
            this.config.paymentApiUrl + '/charges/' + chargeId + '/refund?token=' + this.resolvedToken,
            dto,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }
}
